import { useEffect, useRef } from "react"

const toPositiveInt = (value, fallback) => {
  const parsed = Number.parseInt(String(value || ""), 10)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

const DEFAULT_REFRESH_MS = 60 * 1000

export const getAutoRefreshIntervalMs = () => {
  const raw = process.env.REACT_APP_AUTO_REFRESH_MS
  if (String(raw || "").trim() === "") return DEFAULT_REFRESH_MS
  return toPositiveInt(raw, 0)
}

export const useAutoRefresh = (callback, options = {}) => {
  const {
    enabled = true,
    pauseWhenHidden = true,
    shouldRun = null,
    deps = [],
  } = options

  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const intervalMs = getAutoRefreshIntervalMs()
    if (!enabled || intervalMs <= 0) return undefined

    const intervalId = window.setInterval(() => {
      if (pauseWhenHidden && typeof document !== "undefined" && document.visibilityState !== "visible") return
      if (typeof shouldRun === "function" && !shouldRun()) return
      callbackRef.current?.()
    }, intervalMs)

    return () => window.clearInterval(intervalId)
  }, [enabled, pauseWhenHidden, shouldRun, ...deps])
}
